import e from './style.module.css'
import { useEffect, useState } from "react"
import axios from "axios"

import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Form from 'react-bootstrap/Form'
import Table from 'react-bootstrap/Table'

import Button from 'components/common/Button/Button'

import { IGetProducts } from 'Interface/ApiResponses/products/GetProducts'
import polizaImg from 'assets/img/polizas.svg'
import { SkeProducts } from 'components/common/Skeleton/SkeProducts'
import { get_products } from 'Utils/Const/ApirUrl'
//import {FakeProducts} from 'Utils/fakeData'

const userID= '402-2235824-9'
export const Productos = () => {

  const [loading, setLoading] = useState(true)
  const [allProductos, setAllProductos] = useState<IGetProducts[]>([])
  const [productos, setProductos] = useState<IGetProducts[]>([])


 
  useEffect(() => {
    /*setAllProductos(FakeProducts);*/
    axios.get(get_products+'?User='+userID)
      .then((response) => {
        setAllProductos(response.data)
      })
      .catch((error) => {
        console.group('error')
        console.log(error)
        console.groupEnd()
      })
  }, [])
 
 const handleClick = (url:string)=>{
  window.open(url,'_blank','noopener noreferrer')
 }

  const filterBy = (e: React.ChangeEvent<HTMLSelectElement> ) => {
    if (e.target.value === "" ){
      setProductos([])
    } else if(!!allProductos ) {
        setProductos(allProductos.filter((elem) =>
            elem['financialEntity'].toLowerCase().includes(e.target.value.toLowerCase())));
        setLoading(false);
    }
  }


  return (<>

    <div className='container pb-3 mt-2'>
      <Row>
        <Col md={3}>
          <img src={polizaImg} alt='Imagen vector con folder' className={e.img_polizas} />
      </Col>
        <Col md={9} className='text-center text-md-start'>
          <h3>Solicitar productos</h3>
          <p className='mb-1'>Ofrecemos diferentes opciones para que elijas la entidad financiera con coberturas que más se ajuste a tus necesidades.</p>
          <div className='d-flex justify-content-center justify-content-md-start'>
            <span className='deco_line' />
          </div>
          <Row className='mt-3 mt-lg-5'>
            <Col className='col-11 col-lg-4'>
              <Form.Label column sm={12} className='bold'>Seleccione entidad financiera:</Form.Label>
              <Form.Select 
              aria-label='Ver productos por entidad financiera' 
              onChange={filterBy} 
              defaultValue={''}               
              >
                <option value='' disabled>Seleccionar entidad</option>
                {
                 Array.from(
                    new Set(
                      allProductos?.map(
                        obj=>obj.financialEntity.toLowerCase()
                      )
                    )
                  ).map((type, i)=>(
                    <option 
                      key={`${type}_${i}`} 
                      value={type}
                      className='text-capitalize'
                    >
                      {type}
                    </option>
                  ))
                }
              </Form.Select>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>

    <div  className={`container-fluid py-4 mb-5 `}>
      <div className='container'>
      
      {
        loading 
        ?
        ( <>
          <p className='text-center text-lg-start '><strong>En espera de selección de entidad finanaciera</strong></p>
          <SkeProducts/>
        </>)
        :
        (<>
          <h5 className='text-center text-lg-start '>Listado de productos disponibles</h5>
          <Table hover size="sm" className={e.tablePol}>
            <thead>
              <tr>
                <th>#</th>
                <th>Producto</th>
              </tr>
            </thead>
            <tbody>
              {
                productos.map((data, i) => (
                  <tr key={data.id +i}>
                    <td>{i+1}</td>
                    <td>{data.name}</td>
                    <td>
                    <Button type='button' value='Solicitar' onClick={()=> {
                    handleClick(data.url)
                  }} />
                    </td>
                  </tr>
                ))
              }
              
            </tbody>
          </Table>
        </>)
      }
      </div>
    </div>
    

  </>)
}
